import client from "@/lib/api";

export const ORDER_STATUSES = [
    { value: "new", label: "New" },
    { value: "in_progress", label: "In Progress" },
    { value: "fulfilled", label: "Fulfilled" },
    { value: "done", label: "Done" },
    { value: "cancelled", label: "Cancelled" },
];

export const ALL_ORDER_STATUSES = [...ORDER_STATUSES, { value: "awaiting_payment", label: "Awaiting payment" }];

export const ENQUIRY_STATUSES = [
    { value: "new", label: "New" },
    { value: "in_progress", label: "In Progress" },
    { value: "done", label: "Done" },
];

export const SPECIAL_SECTIONS = ["specials", "bundles", "pre-cooked-dinners"];

export const PAYMENT_LABELS = { payfast: "Card (PayFast)", cash: "Cash on collection", whatsapp: "WhatsApp order" };

export const statusLabel = (list, v) => list.find((s) => s.value === v)?.label || v;

export const fieldCls =
    "w-full mt-1 bg-brand-ink border border-brand-line px-3 py-2 rounded-sm text-sm text-brand-cream focus:outline-none focus:border-brand-olive";

export const labelCls = "text-[11px] uppercase tracking-[0.18em] text-brand-gold";

export const errMsg = (err, fallback) => {
    const d = err?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => e?.msg || "").join(" ");
    return fallback;
};

export const downloadCsv = async (path, filename) => {
    const { data } = await client.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
};
